const domain = window.location.hostname; // Obtiene solo el dominio
let totemActive = false;

if (domain.includes('totem.citylok')) {
  totemActive = true;
}

export const environment = {
  production: false,
  backend: "https://dev.apiv2.citylok.com/api",
  backend_v2: "https://dev.apiv2.citylok.com/api",
  chatbot: "https://dev.api.ventas.citylok.com",
  login: "https://dev.apiv2.citylok.com",
  media: "https://dev.apiv2.citylok.com/",
  front: "https://dev.citylok.com",
  sales: "https://dev.ventas.citylok.com",
  keys: {
    stripe: 'pk_live_51N166hBqYAOLE3PaiwLQdB3R63iniMCzACnJIcZy2vCIJZYRxZqeNdzuhWdhbKOtGZX4DfLo2wjz8tvmECcp4mvf009zAOB9wq',
    facebook: '1738809706333953',
    google: '744858171463-2ipje4876setrcv8j3gemaflacci6mn7.apps.googleusercontent.com'
  },
  debug: false,
  wp_api: "https://wp.citylok.com",
  totem: totemActive,
  // Wallet (Google y Apple): encendido en todos los entornos. El endpoint del
  // back ya devuelve 503 si Wallet no está configurado en el servidor, así que
  // este flag es lo único que hace falta para no enseñar el botón.
  wallet: true,
  user_totem: 'totem_teatroideal@citylok.com',
  pass_totem: 'GFfZ1H6uvpcEyQ'
};

// export const environment = {
//   production: true,
//   backend: "https://api.citylokv2.sdi.es/api",
//   login: "https://api.citylokv2.sdi.es",
//   media: "https://api.citylokv2.sdi.es",
//   front: "https://citylokv2.sdi.es",
//   keys: {
//     stripe: 'pk_test_51N166hBqYAOLE3PaTb69ojBA3eg12VzPGvx7bUIZRDJyemLYnDc0Mx3ZmlWngWTvf1IMANMcgJRI7E3fpGAPg8fL00gXeQMExy',
//     facebook: '1738809706333953',
//     google: '744858171463-2ipje4876setrcv8j3gemaflacci6mn7.apps.googleusercontent.com'
//   },
//   debug: false
// };


// export const environment = {
//   production: true,
//   backend: "https://dev.api.citylok.com/api",
//   login: "https://dev.api.citylok.com",
//   media: "https://dev.api.citylok.com",
//   front: "https://dev.citylok.com",
//   keys: {
//     stripe: 'pk_test_51N166hBqYAOLE3PaTb69ojBA3eg12VzPGvx7bUIZRDJyemLYnDc0Mx3ZmlWngWTvf1IMANMcgJRI7E3fpGAPg8fL00gXeQMExy',
//     facebook: '1738809706333953',
//     google: '744858171463-2ipje4876setrcv8j3gemaflacci6mn7.apps.googleusercontent.com'
//   },
//   debug: false
// };
